const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var FlipCamera24 = function FlipCamera24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "M22.279 11.4594C21.7487 11.6158 21.1938 11.3065 21.0396 10.7686C19.3494 4.87233 14.3006 3.52898 12.2533 3.52898C10.1223 3.52898 6.30573 4.13915 3.88072 8.47441L6.64115 8.47441C7.19341 8.47441 7.6411 8.92862 7.6411 9.4889C7.6411 10.0492 7.19341 10.5034 6.64115 10.5034L1.99995 10.5034C1.44769 10.5034 1 10.0492 1 9.4889V4.50718C1 3.94689 1.44769 3.49269 1.99995 3.49269C2.55221 3.49269 2.9999 3.94689 2.9999 4.50718V6.12747C5.92037 2.11014 9.98996 1.5 12.2533 1.5C14.8471 1.5 20.9372 3.14569 22.96 10.2019C23.1142 10.7399 22.8093 11.3029 22.279 11.4594Z",
      fill: "currentColor",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M1.72319 13.5397C2.25383 13.3855 2.80803 13.694 2.96102 14.2287C4.65336 20.1426 9.70516 21.485 11.7467 21.485C13.8756 21.485 17.6966 20.8747 20.123 16.5197L17.3588 16.5197C16.8066 16.5197 16.3589 16.0686 16.3589 15.5122C16.3589 14.9557 16.8066 14.5047 17.3588 14.5047L22 14.5047C22.5523 14.5047 23 14.9557 23 15.5122V20.5026C23 21.0591 22.5523 21.5101 22 21.5101C21.4478 21.5101 21.0001 21.0591 21.0001 20.5026V18.868C18.0811 22.8875 14.0128 23.5 11.7467 23.5C9.1471 23.5 3.06002 21.8481 1.0394 14.7869C0.886402 14.2522 1.19255 13.6938 1.72319 13.5397Z",
      fill: "currentColor",
    })
  );
};
FlipCamera24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: FlipCamera24,
};
export function FlipCamera(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'FlipCamera' icon. Please use one of the available sizes: '24'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
